import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueAwesomeSwiper from 'vue-awesome-swiper'
import ElementUI from 'element-ui';
import VideoPlayer from 'vue-video-player'
import echarts from 'echarts'
import 'element-ui/lib/theme-chalk/index.css';
import animated from 'animate.css'
// import 'swiper/css/swiper.css'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
Vue.config.productionTip = false;
// 全局事件总线，用于分发绑定事件
Vue.prototype.$bus=new Vue()
Vue.use(VueAwesomeSwiper)
Vue.use(animated)
Vue.use(ElementUI)
Vue.use(VideoPlayer)
Vue.prototype.$echarts = echarts
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
